<template>
  <section class="box pt-5">
    <BackButtonSingelPage class="mb-3" path="/account/orders" />
    <div v-if="theInvoice !== null" class="OrderView d-flex flex-column ga-4">
      <DocInfo
        :docNumber="invoiceId"
        :docTypeName="$t('SingelInvoice.invoiceNumber')"
        :theDoc="theInvoice"
        :mode="mode"
      >
        <template v-if="this?.theInvoice?.link" #top-left-action-btn>
          <BaseButton
            @click="downloadPdf"
            paddingTop="8px"
            paddingBottom="8px"
            paddingLeft="10px"
            paddingRight="10px"
          >
            <v-icon
              class="ml-1"
              size="18"
              color="white"
              icon="mdi-file-download-outline"
            />
            <span class="btn-text">{{
              $t("SingelInvoice.downloadPdfButtn")
            }}</span>
          </BaseButton>
        </template>
      </DocInfo>
      <!-- {{ this.$store.getters["Orders/getOrder"](this.cartOrOrder).OrderLines }} -->
      <!-- {{ this.theInvoice }} -->
      <DocProducts
        :docTypeName="$t('SingelInvoice.invoiceDetails')"
        :orderLines="theInvoice.DeliveryLines"
        :mode="mode"
      >
        <template #doc-summary>
          <InnerBox
            v-if="theInvoice?.DeliveryLines?.length > 0"
            :fontWeight="700"
            class="order-summary"
            :title="$t('SingelInvoice.summaryTitle')"
          >
            <template #content>
              <div class="d-flex flex-column ga-2">
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("SingelInvoice.CountItems") }}</label>
                  <span>{{ invoiceItemsCount }}</span>
                </div>
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("SingelInvoice.PackagesCount") }}</label>
                  <span>{{ theInvoice.DeliveryLines.length ?? 0 }}</span>
                </div>
                <span class="my-2 seperate-line" />
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("SingelInvoice.priceBeforeTax") }}</label>
                  <span
                    >{{ currency
                    }}{{
                      formatPrice(
                        isInvoiceHasDiscount
                          ? priceBeforeDiscount
                          : theInvoice.totalWithOutVat
                      )
                    }}</span
                  >
                </div>
                <div
                  v-if="isInvoiceHasDiscount"
                  class="d-flex justify-space-between order-info"
                >
                  <label
                    >{{ $t("SingelInvoice.priceInludeDiscount") }}
                    {{ theInvoice?.discountPercent }}%</label
                  >
                  <span
                    >{{ currency
                    }}{{
                      !isNaN(formatPrice(priceWithDiscount))
                        ? Number(
                            formatPrice(priceWithDiscount)
                          ).toLocaleString()
                        : 0
                    }}</span
                  >
                </div>
                <div class="d-flex justify-space-between order-info">
                  <label
                    >{{ $t("SingelInvoice.tax") }}
                    {{ `${theInvoice.tax}%` }}</label
                  >
                  <span
                    >{{ currency
                    }}{{
                      !isNaN(formatPrice(theInvoice.totalVat))
                        ? Number(
                            formatPrice(theInvoice.totalVat)
                          ).toLocaleString()
                        : 0
                    }}</span
                  >
                </div>
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("SingelInvoice.priceIncludeTax") }}</label>
                  <span
                    >{{ currency
                    }}{{
                      !isNaN(formatPrice(theInvoice.amount))
                        ? Number(
                            formatPrice(theInvoice.amount)
                          ).toLocaleString()
                        : 0
                    }}</span
                  >
                </div>
              </div>
            </template>
          </InnerBox>
        </template>
      </DocProducts>
      <DocNotes :mode="mode" :note="theInvoice?.notes" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import DocInfo from "../helpers/DocInfo.vue";
import DocNotes from "../helpers/DocNotes.vue";
import DocProducts from "../helpers/DocProducts.vue";
import InnerBox from "../UI/InnerBox.vue";
import BackButtonSingelPage from "../UI/BackButtonSingelPage.vue";
import BaseButton from "../UI/BaseButton.vue";

export default {
  components: {
    // BaseLightBox,
    DocInfo,
    DocNotes,
    DocProducts,
    InnerBox,
    BackButtonSingelPage,
    BaseButton,
  },
  mounted() {
    this.getInvoice();
  },
  data() {
    return {
      theInvoice: null,
      cartOrOrder: "",
      currency: "₪",
      invoiceId: 0,
    };
  },
  methods: {
    downloadPdf() {
      if (this?.theInvoice?.link) {
        window.open(this.theInvoice.link, "_blank");
      }
    },
    formatPrice(price) {
      if (Number.isInteger(price)) {
        return price?.toString();
      } else {
        return price?.toFixed(2);
      }
    },
    async getInvoice() {
      this.invoiceId = this.$route.params.invoiceId;
      this.theInvoice = {
        ...this.$store.getters["Invoices/getInvoice"](this.invoiceId),
      };
      if (!Object.keys(this.theInvoice).length) {
        this.theInvoice = await this.$store.dispatch(
          "Invoices/getInvoice",
          this.invoiceId
        );
      }
    },
  },
  computed: {
    priceWithDiscount() {
      let discountCalc = this.priceBeforeDiscount - this.theInvoice?.amount;
      if (this.theInvoice?.tax) {
        discountCalc =
          this.priceBeforeDiscount - this.theInvoice?.totalWithOutVat;
      }
      return discountCalc < 0 ? discountCalc * -1 : discountCalc;
    },
    isInvoiceHasDiscount() {
      return this.theInvoice.discountPercent > 0;
    },
    priceBeforeDiscount() {
      return this.theInvoice.DeliveryLines.reduce((acc, line) => {
        return acc + line.Part.price * line.quant;
      }, 0);
    },
    mode() {
      return "invoices";
    },
    invoiceItemsCount() {
      return this.theInvoice.DeliveryLines.reduce((acc, line) => {
        return acc + line.quant;
      }, 0);
    },
    ...mapGetters({
      getParts: "Parts/getParts",
      getUserPhone: "AuthModule/getUserPhone",
      getCustData: "AuthModule/getCustomerData",
      getTaxPercent: "Orders/getTaxPercent",
      isLoading: "isLoading",
    }),
  },
};
</script>

<style scoped lang="scss">
.singel-doc-page {
  max-width: 1200px !important;
}

.order-summary {
  max-width: 360px;

  label {
    font-size: $mediumTextSize;
    font-weight: 400;
    line-height: 21.33px;
    text-align: right;
    color: $DeepGray;
  }

  span {
    font-size: $mediumTextSize;
    font-weight: 500;
    line-height: 21.33px;
    text-align: right;
    color: black;
  }
}
.inner-box-title {
  font-weight: 700 !important;
}

.order-butttons-container {
  display: flex;
  gap: 20px;
}

@media only screen and (max-width: 601px) {
  .order-butttons-container {
    justify-content: space-around;
  }
}

.shipping-info {
  display: flex;
  gap: 30px;
}

.shipping-actions {
  display: grid;
  grid-row-gap: 10px;
}

.shipping-address,
.shipping-number {
  font-size: $smallTextSize;
}
.shipping-number {
  font-weight: 600;
}
.shipping-date {
  font-size: $extraSmallTextSize;
}
.light-box-headline {
  margin-bottom: 30px;
}
p {
  margin: 0;
}

select {
  display: block;
  border-radius: 10px;
  border-color: lightgrey;
  font-size: $mediumTextSize;
  font-weight: 400;
  line-height: 21.33px;
  text-align: right;
}

.inner-box {
  textarea {
    border: unset;
  }
  input {
    border: unset !important;
  }
}
textarea {
  height: 9rem;
  border-radius: 7px;
  padding: 15px;
  border-color: #dbdbdb;
  width: 100%;
}
textarea:focus {
  outline: none !important;
  border: 1px solid #6daf2d57;
  box-shadow: 0 0 10px #6daf2d69;
}

h1 {
  font-size: $largTextSize;
  font-weight: 600;
}

.doc-number-title {
  font-weight: 400;
  color: $orderLineColor;
}

input[type="date"],
input[type="text"] {
  width: 33% !important;
  display: inline !important;
  font-size: $smallTextSize !important;
}

@media (max-width: 601px) {
  .OrderView > div {
    margin-bottom: 40px !important;
  }
  .row .col:last-child {
    padding-right: 10px !important;
  }
}
.shipping-actions a {
  font-size: $smallTextSize !important;
  background: $secondaryBackgroundButtonColor !important;
}
.shipping-actions {
  margin-top: 20px !important;
}
.send-order {
  display: inline-flex;
  align-items: center;

  font-size: $mediumTextSize;
  background: $cartMainColor;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: right;
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 15px;
  padding: 25px;
  color: white;
  max-width: max-content;

  border: i {
    margin-right: 10px;
  }
  i:lang(en) {
    padding-right: 10px;
    transform: rotate(180deg);
  }
}

@media only screen and (max-width: 601px) {
  .send-order:first-of-type {
    max-width: unset !important;
    width: 100% !important;
  }
}

.send-order.orders {
  background: $ordersMainColor !important;
  font-size: $smallTextSize !important;
  padding-bottom: 27px;
}

.seperate-line {
  height: 1px;
  background: var(--Lite-Grey, #dcdcdc);
}

.btn-text {
  font-size: $smallTextSize;
  font-weight: 400;
}
</style>
